import React, { useState } from 'react'
import { Button } from '@sureco/design-system'
import { CensusFileMemberUpdatesSchema } from '../../api/dto/census-file-member-updates-schema.dto'
import { EligibilityData } from '../../types/eligibility-data'

interface SaveEligibilityChangesButtonProps {
  employeeId: string
  eligibilityData: EligibilityData
  updateMemberUpdates: (
    employeeId: string,
    updates: Partial<CensusFileMemberUpdatesSchema>
  ) => void
  disabled: boolean
  onSave: () => void
}

const SaveEligibilityChangesButton: React.FC<
  SaveEligibilityChangesButtonProps
> = ({
  employeeId,
  eligibilityData,
  updateMemberUpdates,
  disabled,
  onSave,
}) => {
  const [loading, setLoading] = useState(false)

  const handleSave = () => {
    setLoading(true)

    // Prepare `memberUpdates` data
    const updates: Partial<CensusFileMemberUpdatesSchema> = {
      benefitsEligible: eligibilityData.benefitsEligible,
      benefitsEffectiveDate: eligibilityData.benefitsEffectiveDate,
      enrollmentStartDate: eligibilityData.enrollmentStartDate,
      enrollmentEndDate: eligibilityData.enrollmentEndDate,
      doNotCreateEnrollment: eligibilityData.doNotCreateEnrollment,
    }

    // Update `memberUpdates`
    updateMemberUpdates(employeeId, updates)

    // Reset button state
    onSave()
    setLoading(false)
  }

  return (
    <Button
      onClick={handleSave}
      size="large"
      variant="primary"
      disabled={disabled || loading}
    >
      {loading ? 'Saving...' : 'Save Changes'}
    </Button>
  )
}

export default SaveEligibilityChangesButton
